import { Filter } from '@devexpress/dx-react-grid'

const filterByDefaultValue = (value: any, filter: Filter, row: any) => {
  if (!filter.value.length) {
    return true
  }

  if(filter?.value?.toLowerCase() === 'yes' && value === 1){
    return true
  }
  if(filter?.value?.toLowerCase() === 'no' && value !== 1){
    return true
  }
  return false
}

export default filterByDefaultValue
